

































import { Component, Vue } from "vue-property-decorator";
import JobList from "./components/jobList/JobList.vue";
import TopNav from "./components/TopNav.vue";
import Store from "@/store/store";

@Component({
  components: {
    JobList,
    TopNav
  }
})
export default class App extends Vue {
  protected redirect: boolean = true;
  protected get isRedirect() {
    return this.redirect;
  }
  protected changeRedirect() {
    this.redirect = false;

    window.location.href = "http://crm.prospect365.com";
  }
  protected get isErrored() {
    return Store.state.User.errored;
  }
  protected get IsLoggedIn() {
    return Store.state.User.AccessToken || Store.state.User.errored;
  }
}
